import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20stars%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20film%20grain%20texture%2C%20abstract%20cinematic%20composition%2C%20no%20text%2C%20professional%20film%20photography&width=640&height=360&seq=jiubo-media-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20set%20with%20cameras%20and%20equipment%2C%20warm%20lighting%2C%20cinematic%20atmosphere%2C%20film%20production%20aesthetic%2C%20rich%20contrast%2C%20no%20text%2C%20professional%20photography&width=640&height=360&seq=jiubo-media-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Film%20critic%20style%20thumbnail%20with%20movie%20posters%20and%20review%20elements%2C%20dramatic%20warm%20lighting%2C%20cinematic%20aesthetic%2C%20rich%20burgundy%20and%20amber%20tones%2C%20no%20text%2C%20professional%20photography&width=640&height=360&seq=jiubo-media-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Classic%20film%20still%20with%20dramatic%20lighting%20and%20artistic%20composition%2C%20warm%20golden%20tones%2C%20movie%20scene%20aesthetic%2C%20film%20grain%2C%20rich%20shadows%2C%20no%20text%2C%20professional%20cinematography&width=640&height=360&seq=jiubo-media-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Movie%20compilation%20thumbnail%20with%20multiple%20film%20strips%20and%20reels%2C%20warm%20cinematic%20lighting%2C%20golden%20and%20crimson%20accents%2C%20dynamic%20composition%2C%20no%20text%2C%20professional%20film%20industry%20aesthetic&width=640&height=360&seq=jiubo-media-05&orientation=landscape",
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-600">
            预告片、花絮、解说，全方位感受电影魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-950/60 text-background-50 group-hover:bg-primary-500 transition-all duration-300">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-background-950/70 text-background-50 text-[10px] md:text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="text-xs text-foreground-500 bg-background-200 px-1.5 py-0.5 rounded">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {item.views}次播放
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}